<template>
  <div class="m_detail">
    <van-nav-bar title="" class="topTitleBG" />
    <van-nav-bar
      :title="title"
      left-arrow
      @click-left="onClickLeft"
      class="topTitle"
    />
    <div class="content" v-html="content"></div>
    <div v-show="showAttachmentAppend" style="background: rgba(0, 0, 0, 0)">
      <div class="downloadTitle">文件下载</div>
      <div class="download">
        <van-list>
          <van-cell
            class="vanCell"
            v-for="item in attachment1List"
            :key="item.AttachmentID"
            :title="item.AttachmentName"
            @click="dowloadFile(item.AttachmentFileName)"
          />
        </van-list>
      </div>
    </div>
    <div v-show="showAttachmentChart">
      <div class="downloadTitle">表格下载</div>
      <div class="download">
        <van-list>
          <van-cell
            class="vanCell"
            v-for="item in attachment2List"
            :key="item.AttachmentID"
            :title="item.AttachmentName"
            @click="dowloadFile(item.AttachmentFileName)"
          />
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import { searchArticle } from "../../utils/api.js";
import axios from "axios";

export default {
  name: "m_detail",
  mounted: function () {
    console.log("从何处进来", this.$route.params.inRole);
    // console.log("要查询文章的id", this.$route.params.articleID);
    console.log("路由要携带的文章id", this.$route.params.articleID);
    this.whereIn = this.$route.params.inRole;
    this.articleID = this.$route.params.articleID;
    if (this.articleID) {
      this.goInterface();
    }
  },
  data() {
    return {
      title: "标题",
      // 判断是从那里进入详情页 搜索还是四个对象 取值为search或oopList
      whereIn: "",
      //要查询文章的id
      articleID: 0,
      //显示的主内容
      content: "",
      //附件一列表
      attachment1List: [],
      //附件二列表
      attachment2List: [],
      //是否显示文件或者表格 false不显示
      showAttachmentAppend: false,
      showAttachmentChart: false,
    };
  },
  methods: {
    //点击下载文件
    dowloadFile(AttachmentFileName) {
      console.log("要下载的文件id", AttachmentFileName);

      axios({
        method: "post",
        url:
          "https://jwgf.henu.edu.cn:443/attachment/download/" +
          AttachmentFileName,
        responseType: "blob",
      }).then((res) => {
        console.log(res.data);
        // this.contentList = res.data;
        this.toDownload(res.data);
      });
    },

    toDownload(data) {
      alert("相关文件请到电脑端下载！");
      // if (!data) {
      //   return;
      // }

      // if (confirm("是否下载此附件")) {
      //   let url = window.URL.createObjectURL(new Blob([data]), {
      //     // let url = window.URL.createObjectURL(data, {
      //     type: "application/pdf;chartset=UTF-8",
      //   });
      //   let link = document.createElement("a");
      //   link.style.display = "none";
      //   link.href = url;
      //   link.setAttribute("download", this.theHref);
      //   document.body.appendChild(link);
      //   link.click();
      // }
    },

    //van-nav-bar左侧点击返回
    //可能返回到search或oopList
    onClickLeft: function () {
      console.log("返回点击了，返回上一页");
      switch (this.whereIn) {
        case "search":
          this.$router.replace("./m_search");
          break;
        case "oopList":
          this.$router.replace("/m_oopList");
          break;
        default:
          this.$router.replace("/m_home");
          break;
      }
    },

    //调接口统一地
    goInterface() {
      searchArticle(this.articleID).then((result) => {
        this.dealMSG(result);
      });
    },

    //处理返回来的信息 分开附件内容
    dealMSG(result) {
      console.log(result);

      this.title = result[0].BusinessName;
      this.content = result[0].BusinessContent;

      for (let i = 1; i < result.length; i++) {
        if (result[i].AttachmentType == 0) {
          this.attachment1List.push(result[i]);
        } else {
          this.attachment2List.push(result[i]);
        }
      }

      console.log(this.attachment1List);
      console.log(this.attachment2List);

      // 根据文件和表格列表中有没有内容决定是否显示相应内容
      if (this.attachment1List.length >= 1) {
        this.showAttachmentAppend = true;
      } else {
        this.showAttachmentAppend = false;
      }
      if (this.attachment1List.length >= 1) {
        this.showAttachmentChart = true;
      } else {
        this.showAttachmentChart = false;
      }
    },
  },
};
</script>

<style scoped>
.Detail {
  padding-bottom: 50px;
}
.m_detail {
  text-align: left;
  width: 100vw;
  height: auto;
  padding-bottom: 10px;
  background: #fff;
}

.content {
  width: 94vw;
  font-size: 18px;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  background-size: 100vw;
  box-sizing: border-box;
  padding: 0;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.content /deep/ p img {
  max-width: 96vw;
}

.downloadTitle {
  font-size: 18px;
  padding-left: 3vw;
  font-weight: bold;
}
.download {
  width: 94vw;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  min-height: 5vh;
  background-color: whitesmoke;
}
.van-cell__title {
  color: #00589f;
}
.van-cell {
  line-height: none;
}
.van-cell__title,
.van-cell__value {
  font-size: large;
  color: #333333;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.m_bottom {
  position: absolute;
  top: 93%;
  width: 100%;
  text-align: center;
  font-weight: 300;
  font-size: 20px;
  color: #999999;
  line-height: 48px;
}
.van-nav-bar__arrow {
  font-size: 20px;
}
.van-nav-bar__content {
  padding: 5px 2px;
}
.van-nav-bar__title {
  font-size: 20px;
}
.van-cell {
  padding: 10px 20px;
  background: #f3f8fd;
}
.van-collapse-item__title--expanded {
  background: #f3f8fd;
}
.van-collapse-item__icon {
  display: none;
}
van-cell__right-icon {
  display: none;
}
.topTitleBG {
  background-color: transparent;
}
.topTitle {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}
</style>